import { render, staticRenderFns } from "./ReferentForm.vue?vue&type=template&id=5dc2ff81&scoped=true&"
import script from "./ReferentForm.vue?vue&type=script&lang=js&"
export * from "./ReferentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc2ff81",
  null
  
)

export default component.exports